export default "/_next/static/media/enjoei-collectionwidget2-1024x408.8b087f409dcb22836a1b610877646b19.png";